import React, { useState, useEffect, useContext, useCallback } from "react";
import { callApi } from "bodycodi/cmap/app/js/common";

import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

import main from "bodycodi/cmap/app/img/icon-main-center-small.png";
import coach_default from "bodycodi/cmap/app/img/member-profile-empty.png";
import CenterProfileUpdPop from "./centerProfileUpdPop";

type CenterProfilePop = {
  update: Function;
};

const CenterProfilePopWrap = ({ update }: CenterProfilePop) => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "CENTER_PROFILE_POP", open: { centerPropfilePop: false } });
  };

  return (
    <CustomDialog open={state.centerPropfilePop} onClose={handleClose}>
      <PopupHeader onClickBack={handleClose} title="센터별 프로필 설정" />
      {state.centerPropfilePop && <CenterProfilePop update={update} />}
    </CustomDialog>
  );
};

const CenterProfilePop = ({ update }: CenterProfilePop) => {
  const { dispatch } = useContext(DispatchContext);
  const [PartnerBranchList, setPartnerBranchList] = useState([]);
  const [center, setCenter] = useState({});
  const [refresh, setRefesh] = useState(1);
  const updateP = useCallback(() => {
    setRefesh(refresh + 1);
  }, [refresh]);

  useEffect(() => {
    callApi("/partner/branches/coaches", {}, "GET").then((res) => {
      setPartnerBranchList(res);
    });
  }, [refresh]);

  const clickUpd = (d: any) => () => {
    setCenter(d);
    dispatch({
      type: "POP_UP_OPEN",
      id: "CENTER_PROFILE_UPD_POP",
      open: { centerProfileUpdPop: true },
    });
  };

  const profileList = PartnerBranchList.map((d: any) => {
    return (
      <div className="center-profile" key={d.seqPartner + "" + d.seqPartnerBranch}>
        {d.mainPartnerFlag === 1 && (
          <div className="main-center">
            <img src={main} />주 연동센터
          </div>
        )}
        <div className="profile-wrap">
          <div className="info">
            <div className="bold">{d.coachName}</div>
            <div>{d.partnerName}</div>
            <div>{d.partnerBranchName}</div>
          </div>
          <img className="profile" src={d.coachImgUrl ? d.coachImgUrl : coach_default} />
        </div>
        <div className="decs">
          {d.bpayComment ? d.bpayComment : `안녕하세요! ${d.coachName} 강사입니다.`}
        </div>
        <div className="btn-wrap">
          <div className="btn" onClick={clickUpd(d)}>
            수정하기
          </div>
        </div>
      </div>
    );
  });

  return (
    <>
      <div className="popup-body center-profile-pop">
        <div className="text">
          바디코디 회원앱에서 개인레슨 이용권 구매 시 상세페이지의 강사 소개에 보여집니다. 미 입력시
          기본 인사말로 등록됩니다.
        </div>
        <div>{profileList}</div>
      </div>
      <CenterProfileUpdPop d={center} update={updateP} updateProflie={update} />
    </>
  );
};

export default CenterProfilePopWrap;
